import { Store, StoreConfig } from '@datorama/akita';
import { createInitialUsersState, UsersState } from './users.model';

@StoreConfig({ name: 'users', resettable: true })
export class UsersStore extends Store<UsersState> {
  constructor() {
    super(createInitialUsersState());
  }
}

export const usersStore = new UsersStore();